<template>
  <div class="pa-4" v-allowed="'manage_flowcharts_data'">
    <v-card class="bjjlink-card pa-3" elevation="0">
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined :disabled="addingFlowchart" class="mr-2" @click="newFlowchartDialog = true" small elevation="0"
          right color="primary">
          {{ $t('message.add') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card elevation="0">
      <v-skeleton-loader v-if="loading" type="list-item, list-item"></v-skeleton-loader>
      <v-list class="text-left pa-1">
        <template v-for="(i, index) in flowcharts">
          <v-list-item :key="'flowchart_' + i._id" @click="goToFlowchart(i._id, i.name)">
            <v-list-item-content>
              <v-list-item-title>
                {{ i.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t('message.last_update') }}: {{ $d(new Date(i.lastUpdate), "month_day_year", $i18n.locale)
                }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ $t('message.nodes') }}: {{ i.nodes }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar>
              <img v-if="i.creator && i.creator.userImageSmall" :src="userFile(i.creator.userImageSmall)" />
              <img v-else :src="assets() + '/default-profile-avatar.png'" />
            </v-list-item-avatar>
          </v-list-item>
          <v-divider v-if="index + 1 < flowcharts.length" :key="'flowchart_divider_' + index"></v-divider>
        </template>
      </v-list>
    </v-card>
    <v-dialog v-model="newFlowchartDialog" max-width="90%">
      <v-card>
        <v-card-title class="text-title">
          {{ $t('message.add_flowchart') }}
        </v-card-title>
        <v-card-text class="text-subtitle-1">
          <v-text-field outlined dense :label="$t('message.name')" v-model="flowchart.name"></v-text-field>
          <v-textarea outlined width="100%" v-model="flowchart.description"
            :label="$t('message.description')"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :loading="addingFlowchart" small elevation="0" color="primary"
            @click.stop="addNewFlowchart()">{{
              $t('message.add') }}</v-btn>
          <v-btn class="outlined-btn" small elevation="0" @click.stop="newFlowchartDialog = false">{{
            $t('message.close')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      loading: true,
      items: null,
      flowchart: null,
      flowcharts: [],
      newFlowchartDialog: null,
      addingFlowchart: false,
    };
  },
  components: {
  },
  created() {
    this.flowchart = {
      userId: this.$store.state.user._id,
      name: null,
      description: null
    };
    this.getFlowcharts();
  },
  methods: {
    getFlowcharts() {
      Api().get("flowcharts/admins/managedacademy/" +
        this.$store.state.managedAcademy)
        .then(res => {
          if (res && res.data.flowcharts) {
            this.loading = false;
            this.flowcharts = res.data.flowcharts;
          }
        })
        .catch(err => {
          if (err)
            this.showAlert('error', this.$t('message.oops_not_working'));
        });
    },
    goToFlowchart(id, name) {
      this.navigateTo({ name: "manageflowchart", params: { flowchartId: id }, crumbName: name || null });
    },
    addNewFlowchart() {
      this.addingFlowchart = true;
      Api().post("flowcharts/admins/managedacademy/" +
        this.$store.state.managedAcademy +
        "/flowchart", this.flowchart)
        .then(res => {
          if (res && res.data) {
            this.navigateTo({ name: "manageflowchart", params: { flowchartId: res.data.flowchart._id }, crumbName: this.flowchart.name || null });
          }
        })
        .catch(err => {
          this.addingFlowchart = false;
          if (err)
            this.showAlert('error', this.$t('message.oops_not_working'));
        });
    },
  }
};
</script>

<style scoped>
.video-visibility {
  position: absolute;
  right: 0;
  margin-top: -20px;
  z-index: 2
}

.video-image {
  position: absolute;
  max-width: 100%;
  width: 100%;
  height: 190px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.video-square {
  position: relative;
  width: 100%;
  height: 190px;
  overflow: hidden;
}
</style>